export const acceptedTechStatuses = [
  'EnRoute',
  'Arrived',
  'Departed',
  'Canceled'
];
